/** Ask: a question answered from the project wiki, Sources, and documents with citations, billed in credits */

import type { ProjectSummary } from './project'

/** Credits for one answered question; nothing is charged when the wiki has no answer or the provider fails */
export const ASK_CREDITS = 2

/**
 * Second line of defense for clients that print or forward Ask answers (CLI, MCP): turns any markdown image syntax
 * into a plain link or text so nothing loads an image. The API already drops images with a markdown parser.
 */
export function withoutImageSyntax(markdown: string): string {
  return markdown.replace(/!\[/g, '[').replace(/<img\b[^>]*>?/gi, '')
}

/** `answered`: a cited answer; `not_found`: the wiki does not contain the answer; `failed`: the provider failed */
export type AskStatus = 'running' | 'answered' | 'not_found' | 'failed'

export interface AskCitation {
  kind: 'wiki' | 'source' | 'document'
  /** page slug, Source id, or document slug as written in the marker */
  ref: string
  title: string
  /** App path of the cited item, e.g. /p/core/wiki/deploy */
  path: string
}

export interface AskResult {
  id: string
  requestId: string
  project: Pick<ProjectSummary, 'id' | 'slug' | 'name'>
  question: string
  status: AskStatus
  /** Markdown with [wiki:<slug>], [src:<id>], [doc:<slug>] markers; null unless answered */
  answer: string | null
  citations: AskCitation[]
  creditsCharged: number
  /** Short reason when not answered */
  error: string | null
  createdAt: number
}
